import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import SettingsIcon from '../components/SettingsIcon';

const SettingsPage: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    textAlign: 'center',
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <SettingsIcon sx={{ fontSize: 80, color: '#C10B50', opacity: 0.7 }} />
                </Box>

                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: 600,
                        color: '#18010a',
                        mb: 2
                    }}
                >
                    Settings
                </Typography>

                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        color: '#666',
                        mb: 3,
                        fontWeight: 400
                    }}
                >
                    Coming Soon
                </Typography>

                {/* <Typography
                    variant="body1"
                    sx={{
                        color: '#888',
                        maxWidth: 600,
                        lineHeight: 1.6
                    }}
                >
                    We're developing a comprehensive settings panel to customize your experience.
                    This will include user preferences, system configurations, notification settings,
                    security options, and application-wide customizations.
                </Typography> */}
            </Box>
        </Container>
    );
};

export default SettingsPage; 